export default __webpack_public_path__ + "static/media/heroimage.1df2be2b.gif";